import React, {useState} from 'react';
import Grid from "@mui/material/Grid2";
import ParamTypes from "../../productParamHandler/paramTypes";
import {EditOutlined} from "@mui/icons-material";
import Box from "@mui/material/Box";
import {CardContent, Modal, Paper} from "@mui/material";
import Button from "@mui/material/Button";
import {Trans} from "react-i18next";
import CartManager from "../../managers/cartManager/cartManager";
import hash from "object-hash";


function CartItemParams({params, values, itemKey, productId, disableEdit}) {
    const [selectedParam, setSelectedParam] = useState(null);

    const [newValue, setNewValue] = useState(null);


    const handleOpenModal = (param) => {
        setSelectedParam(param);
    }

    const handleCloseModal = () => {
        setSelectedParam(null);
        setNewValue(null);
    }

    const paramChange = (id, value) => {
        setNewValue(value);
    }

    const onSubmit = () => {
        if (newValue && hash(values[selectedParam.key] || '') !== hash(newValue)) {
            CartManager.changeParam(itemKey, newValue, selectedParam.key, productId);
        }

        handleCloseModal();
    }

    return (
        params ?
            <Grid container gap={1} alignItems={"center"} pb={1} sx={{width: '100%'}}>
                {params.map(param => <Grid key={param.key} container onClick={() => {
                    disableEdit || handleOpenModal(param);
                }} sx={{
                    cursor: disableEdit ? 'initial' : 'pointer',
                    height: '20px',
                    '&:hover .cart-param-edit-button': {
                        opacity: 1,
                        color: 'text.secondary'
                    },
                    flexWrap: 'nowrap'
                }}>
                    {ParamTypes.GET_COMPONENT_FOR_CART(param, values?.[param.key])}
                    <Box className={"cart-param-edit-button"} sx={{
                        pl: 1,
                        height: '20px',
                        opacity: 1,
                        display: disableEdit ? 'none' : 'block',
                        color: {xs: '#b7b7b7', md: '#dfdfdf'}
                    }}>
                        <EditOutlined fontSize="small" sx={{color: 'inherit'}}/>
                    </Box>
                </Grid>)}
                <Modal
                    open={Boolean(selectedParam)}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}
                >
                    <Paper sx={{
                        width: '300px',
                        padding: 2
                    }}>
                        <Grid
                            container
                            flexDirection="column"
                            justifyContent="space-between"
                        >
                            <CardContent sx={{
                                '& div.colors-param-container': {
                                    justifyContent: 'initial'
                                }
                            }}>
                                {selectedParam ? ParamTypes.GET_COMPONENT(selectedParam, paramChange, newValue || values[selectedParam.key], true) : ''}
                            </CardContent>
                            <Box sx={{justifyContent: 'flex-end', display: 'flex'}}>
                                <Button variant={"contained"} sx={{ml: 2}} onClick={onSubmit}>
                                    <Trans i18nKey={'buttons.submit'}/>
                                </Button>
                            </Box>
                        </Grid>
                    </Paper>
                </Modal>
            </Grid> : ''
    );
}

export default CartItemParams;
